let KeyViolationError = require('../KeyViolationError');

const ALLOWED_VALUE_TYPES = [
    typeof(1),
    typeof(''),
    typeof(true),
    typeof(undefined)
];
const RESERVED_KEYS = [
    'accountid',
    'appid',
    'type',
    'eventtype'
];
const SPECIAL_KEYS = [
    'ago',
    'and',
    'as',
    'auto',
    'begin',
    'begintime',
    'compare',
    'day',
    'days',
    'end',
    'endtime',
    'explain',
    'facet',
    'from',
    'hour',
    'hours',
    'in',
    'is',
    'like',
    'limit',
    'minute',
    'minutes',
    'month',
    'months',
    'not',
    'null',
    'offset',
    'or',
    'second',
    'seconds',
    'select',
    'since',
    'timeseries',
    'until',
    'week',
    'weeks',
    'where',
    'with'
];

module.exports = (flex = window.flex) => {

    class NewRelicValidator {
        constructor() { }

        static hasKeys(map, keys) {
            let mapKeys = Object.keys(map).map(key => key.toLowerCase()),
                reducer = (reduction, key) => {
                    if (mapKeys.includes(key)) {
                        reduction.push(key);
                    }

                    return reduction;
                };

            return keys.reduce(reducer, []);
        }

        static validateTypes(map, allowedTypes = ALLOWED_VALUE_TYPES) {
            let mapKeys = Object.keys(map).map(key => key.toLowerCase()),
                reducer = (reduction, key) => {
                    let type = typeof (map[key]);
                    if (!allowedTypes.includes(type)) {
                        reduction.push(`Key:${key}|Type:${type}`);
                    }

                    return reduction;
                };

            return mapKeys.reduce(reducer, []);
        }

        static validate(eventName, values = {}) {
            let { getStore } = flex,
                { tracking } = getStore();

            let reservedKeyViolations = this.hasKeys(values, RESERVED_KEYS),
                specialKeyViolations = this.hasKeys(values, SPECIAL_KEYS),
                typeViolations = this.validateTypes(values),
                isReservedKeyInvalid = !!reservedKeyViolations.length,
                isSpecialKeyInvalid = !!specialKeyViolations.length,
                isTypeInvalid = !!typeViolations.length,
                isEventNameInvalid = !tracking.actionNames.includes(eventName),
                isValid = !(isReservedKeyInvalid || isSpecialKeyInvalid || isTypeInvalid || isEventNameInvalid);

            return {
                isValid,
                isReservedKeyInvalid,
                isSpecialKeyInvalid,
                isTypeInvalid,
                isEventNameInvalid,
                reservedKeyViolations,
                specialKeyViolations,
                typeViolations,
                eventName
            };
        }
    }

    return NewRelicValidator;
};

function _basicPluralize(word, count) {
    if (count === 1) {
        return word;
    }
    if (word === 'is') {
        return 'are';
    }
    return `${word}`;
}